<template>
  <div class="container">
    <center>
      <h2>Survey Links <span>🔗</span></h2>
      <span class="platform-name whatsapp">WhatsApp</span>
      <qrcode :value="qr_deeplink" :options="{ width: 170 }" tag="img"></qrcode>
      <p class="link">{{ whatsapp_link }}</p>

      <hr class="divider">

      <span class="platform-name messenger">Messenger</span>
      <qrcode :value="messenger_link" :options="{ width: 170 }" tag="img"></qrcode>
      <p class="link">{{ messenger_link }}</p>
    </center>
  </div>
</template>

<script>

import moment from 'moment';
import VueQrcode from '@chenfengyuan/vue-qrcode';

export default {
  name: 'Links',
  props: {},
  components: {
    'qrcode': VueQrcode
  },
  computed: {

    survey() {
      let survey_index = this.$route.params.survey_index;
      let surveys = this.$store.state.surveys;
      if (surveys) {
        return surveys[survey_index];
      } else {
        return null;
      };
    },

    whatsapp_link() {
      if (this.survey && this.survey.shortcode) {
        return `voic.co/${this.survey.shortcode}`
      } else {
        return null;
      };
    },

    messenger_link() {
      if (this.survey && this.survey.shortcode) {
        return `m.me/ovoic?ref=${this.survey.shortcode}`
      } else {
        return null;
      };
    },

    qr_deeplink() {
      if (this.survey && this.survey.shortcode) {
        let bot_number = '13513000071';
        if (this.survey.gupshup_phone_number) {
          bot_number = this.survey.gupshup_phone_number;
        };
        if (this.survey.language === 'en' || !this.survey.language) {
          let deeplink = `https://api.whatsapp.com/send?phone=${bot_number}&text=`;
          // Add optional starting message
          if (this.survey.starting_message && this.survey.starting_message.link) {
            deeplink += `${encodeURI(this.survey.starting_message.link)}%0a%0a`;
          };
          deeplink += `%28Send%20this%20message%29%20I%20would%20like%20to%20take%20survey%20code%3a%20${this.survey.shortcode}&source=&data=&app_absent=`;
          return deeplink;
        } else {
          return `https://voic.co/${this.survey.shortcode}`;
        };
      } else {
        return null;
      };
    },

  },
  methods: {}
}
</script>

<style scoped lang="scss">

.container{
  width: 27%;
  margin-left: 4%;
  padding-top: 30px;
  padding-bottom: 28px;
  background-color: white;
  border: 1px solid rgb(216,216,216);
  border-radius: 6px;
  cursor: default;
}

h2{
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 30px;
  span{
    font-size: 18px;
  }
}

.platform-name{
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  color: rgb(40,40,40);
  margin-bottom: 0px;
  &.whatsapp, &.messenger{
    background-size: 20px;
    background-position: right;
    background-repeat: no-repeat;
    padding-right: 25px;
  }
  &.whatsapp{
    background-image: url("../../assets/whatsapp-logo.svg");
  }
  &.messenger{
    background-image: url("../../assets/icons/messenger-btn-icon.svg");
  }
}

img{
  display: block;
  margin: 0 auto;
  margin-top: 10px;
  margin-bottom: 10px;
}

.link{
  font-size: 15px;
  font-weight: 600;
  line-height: 30px;
  cursor: text;
}

hr.divider{
  opacity: .4;
  margin: 30px;
}

</style>
